import { IRootState } from "../../../../../store";

export const selectIssueBoardId = (state: IRootState) => state.issueReducerNew.currentIssueBoardId;
